import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ShowTooltipIfTruncatedDirective } from '@efficiently/client-ui-common';

/**
 * Centre slot of the application header band — shows the open project's name, or
 * "Platform Administrator".
 *
 * Deliberately dependency-free: it reads no service and takes no constructor arguments, so the
 * title always arrives through the `title` input. The binding and its data source are added by the
 * wiring phase; this component stays purely presentational.
 */
@Component({
	selector: 'ds-header-title',
	templateUrl: './header-title.component.html',
	styleUrl: './header-title.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatTooltip, ShowTooltipIfTruncatedDirective],
})
export class HeaderTitleComponent {
	/** `null` — or an empty string — renders nothing at all, not an empty element. */
	public readonly title = input<string | null>(null);
}
